var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showConfirm
    ? _c("div", { staticClass: "my-mask flex-center" }, [
        _c("div", { staticClass: "confirm" }, [
          _c(
            "div",
            { staticClass: "title" },
            [
              _vm._t("title", function() {
                return [_vm._v("确认删除")]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _vm._v("将删除当前评论，不可恢复哦～")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "btns flex-between" }, [
            _c("div", { staticClass: "cancel ", on: { click: _vm.cancel } }, [
              _vm._v("取消")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sure", on: { click: _vm.sure } }, [
              _vm._v("删除")
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }